// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SessionsPlaceholder__container-d45e57 {
  display: flex;
  flex-direction: row;
  padding-top: 16px;
  padding-bottom: 16px;
  padding-inline-start: 24px;
  padding-inline-end: 16px;
}

.SessionsPlaceholder__content-a12103 {
  margin-inline-start: 24px;
}

.SessionsPlaceholder__gap-b65ae7 {
  margin-bottom: 2px;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/Sessions/SessionsPopup/SessionsPlaceholder/SinglePlaceholder.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,0BAAA;EACA,wBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,kBAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: row;\n  padding-top: 16px;\n  padding-bottom: 16px;\n  padding-inline-start: 24px;\n  padding-inline-end: 16px;\n}\n\n.content {\n  margin-inline-start: 24px;\n}\n\n.gap {\n  margin-bottom: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SessionsPlaceholder__container-d45e57`,
	"content": `SessionsPlaceholder__content-a12103`,
	"gap": `SessionsPlaceholder__gap-b65ae7`
};
module.exports = ___CSS_LOADER_EXPORT___;
